import EduzinhoImg from '@/assets/images/eduPerson.png';
import { Box, Stack } from '@mui/material';
import ArrowDown from '../icons/ArrowDown';


type PropsType = {
  message:  JSX.Element | string;
  position?: string;
  content?: JSX.Element | null;
};

const EduzinhoFigure: React.FC<PropsType> = ({ message, position = 'center', content=null }) => {
  return (
    <Stack alignItems={position}>
      <div
        style={{
          color: '#000',
          border: '2px solid black',
          borderRadius: '34px',
          fontSize: '20px',
          textAlign: 'center',
          padding: '14px 10px',
          position: 'relative'
        }}
      >
        {message}
      </div>
      <Box position={'relative'} pt={'20px'}>
        <ArrowDown
          style={{ color: 'black', position: 'absolute', top: 0, left: '81px', width: '67px', height: '49px' }}
        />

        <img src={EduzinhoImg} alt="" />
      </Box>
     {content}
    </Stack>
  );
};

export default EduzinhoFigure;


